import { FC } from 'react'
import styles from './mode-switch.module.scss'
import { useAppDispatch } from '@/redux/store'
import { toggleMode } from '@/redux/theme/slice'
import { EThemeMode } from '@/redux/theme/types'
import { selectedThemeMode } from '@/redux/theme/selectors'
import { useSelector } from 'react-redux'
import classNames from '@/utils/helpers/class-names.helper'

type ModeSwitchProps = {
  className?: string
}

const ModeSwitch: FC<ModeSwitchProps> = ({ className }) => {
  const dispatch = useAppDispatch()
  const mode = useSelector(selectedThemeMode)

  const handleModeChange = () => {
    dispatch(toggleMode())
  }
  return <div className={classNames(styles.modeSwitch, className)} onClick={handleModeChange}>
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={mode === EThemeMode.old ? "m4 20l5-5m0 0v4m0-4H5M20 4l-5 5m0 0V5m0 4h4" : "m15 9l5-5m0 0v4m0-4h-4M9 15l-5 5m0 0v-4m0 4h4"}></path></svg> 
  </div> 
}

export default ModeSwitch
